import type { PiSlackLinkEligibilityResult } from './types';

const PI_SLACK_LINK_ELIGIBILITY_PATH =
	'/gateway/api/pi-gateway/frontend/api/1/accessNotifications/slackLinkEligibleUsers';

export const fetchPiSlackLinkEligibleUsers = async (
	slackLink: string,
	productId: string,
): Promise<PiSlackLinkEligibilityResult> => {
	const response = await fetch(PI_SLACK_LINK_ELIGIBILITY_PATH, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ slackLink, product: productId }),
	});
	if (!response.ok) {
		throw new Error(`HTTP error ${response.status}`);
	}

	const eligibility = (await response.json()) ?? {};
	return { slackLink, eligibleUsers: eligibility?.eligibleUsers };
};
